import config from "@/config/config";

export const getImageUrl = (imageFilename?: string): string => {
  if (!imageFilename) {
    return "";
  }

  if (imageFilename.startsWith("http")) {
    return imageFilename;
  }

  return `${config.apiBaseUrl}/media/image/${imageFilename}`;
};

export const extractImageFilename = (imageUrl?: string): string => {
  if (!imageUrl) {
    return "";
  }

  // Se já é um nome de arquivo (não começa com http), retorna como está
  if (!imageUrl.startsWith("http")) {
    return imageUrl;
  }

  // Extrai o nome do arquivo da URL
  // Ex: "http://localhost:5259/api/media/image/abc123.jpg" -> "abc123.jpg"
  const urlParts = imageUrl.split("/");
  return urlParts[urlParts.length - 1] || "";
};
